export class Node {
  odxId;
  name;

  constructor(odxId: string, name: string, public type?: number) {
    this.name = name;
    this.odxId = odxId;
  }
}
